"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _featuredTout = _interopRequireDefault(require("../featured-tout"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _container = _interopRequireDefault(require("../container"));

var _excluded = ["items"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** Featured tout items */
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    /** Unique identifier */
    body: _propTypes.node,

    /** Tout body content */
    footer: _propTypes.node,

    /** Tout footer content */
    id: _propTypes.string.isRequired,

    /** Tout img src url */
    image: _propTypes.string,

    /** Title content */
    title: _propTypes.node
  })).isRequired
};
var ToutBox = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "featured-touts__ToutBox",
  componentId: "sc-1y7sf0n-0"
})(["border-top:1px solid ", ";"], function (props) {
  return (0, _styles.colors)("border", props);
});
/**
 * FeaturedTouts component takes list of items and renders a FeaturedTout for
 * each. Items are laid out in 2 columns inside of [Container]() component which
 * limits max-width. Root element is [Box](/?selectedKind=Box) and accepts all compatible props.
 */

var FeaturedTouts = function FeaturedTouts(_ref) {
  var items = _ref.items,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(ToutBox, _extends({
    backgroundColor: "background-light"
  }, props), /*#__PURE__*/_react["default"].createElement(_container["default"], {
    py: [2, 3],
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    mx: -24,
    width: 1
  }, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_featuredTout["default"], _extends({
      key: item.id
    }, item));
  }))));
};

FeaturedTouts.propTypes = propTypes;
var _default = FeaturedTouts;
exports["default"] = _default;